import React from 'react';

/**
 * Renders the actions for a card component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {ReactNode} props.children - The child elements to be rendered within the component.
 * @returns {JSX.Element} The rendered CardActions component.
 */
const CardActions = (props) => {
	return (
		<div className={`prc__card--pricing prc_qty_button`}>
			{props.children}
		</div>
	);
};

export default CardActions;
